@let references = referenceCategories$ | async;
@let selectedElement = selectedElement$ | async;
@let updating = updating$ | async;

@if (references) {
  <ng-container
    [ngTemplateOutlet]="references.length ? referencesListTpl : noReferencesTpl"
    [ngTemplateOutletContext]="{ $implicit: { references, selectedElement, updating } }"
  />
}

<ng-template #referencesListTpl let-ctx>
  <ul class="types-list">
    @for (refCategory of ctx.references; track refCategory.name) {
      <li class="types-list-item">
        <p class="element-type">{{ refCategory.name }}</p>
        @for (styleRef of refCategory.styleRefs; track $index) {
          <div
            class="style-tile"
            [class.expanded]="isExpanded(styleRef)"
            [class.default]="isDefault(styleRef)"
          >
            <div class="style-header">
              <mat-icon class="style-icon icon-32" [svgIcon]="styleRef.icon" />
              <span class="style-name">{{ styleRef.styleSheet.name }}</span>
              <span class="references-count">({{ styleRef.elementRefsCount }})</span>
              <div class="actions">
                @if (styleRef.styleSheet.themeId && refCategory.canSetDefaultStyle) {
                  <button
                    class="action-button default"
                    type="button"
                    blazeIconButton
                    blazeTooltip="Default style will be used for all new elements of this kind. You can manage styles in the Themes tab"
                    [disabled]="ctx.updating"
                    (click)="setDefault(styleRef)"
                  >
                    <mat-icon svgIcon="icon_star" />
                  </button>
                }
                <button
                  class="action-button"
                  type="button"
                  blazeIconButton
                  (click)="delete(styleRef)"
                >
                  <mat-icon svgIcon="icon_trash_16" />
                </button>
                @if (styleRef.elementRefsCount) {
                  <button
                    class="action-button expand"
                    type="button"
                    blazeIconButton
                    (click)="toggleExpand(styleRef)"
                  >
                    <mat-icon
                      [svgIcon]="
                        isExpanded(styleRef) ? 'icon_chevron_up_16' : 'icon_chevron_down_16'
                      "
                    />
                  </button>
                }
              </div>
              @if (!styleRef.styleSheet.themeId || styleRef.styleSheet.isThemeDefault) {
                <div class="style-role-icon">
                  <blaze-style-sheet-role-icon [styleSheet]="styleRef.styleSheet" />
                </div>
              }
            </div>
          </div>
          <blaze-scroller>
            @if (isExpanded(styleRef)) {
              <div class="references">
                @if (styleRef.currentPageElementRefs.length) {
                  <p class="references-category">On This Page</p>
                  <ul class="references-list">
                    @for (
                      elementRef of styleRef.currentPageElementRefs;
                      track elementRef.elementId
                    ) {
                      <li
                        class="references-list-item"
                        [class.selected]="isSelected(elementRef, ctx.selectedElement)"
                      >
                        <button
                          type="button"
                          class="reference-button"
                          (click)="navigateToElement(elementRef)"
                        >
                          <mat-icon svgIcon="icon_search_16" />
                          <span>{{ elementRef.name }}</span>
                        </button>
                      </li>
                    }
                  </ul>
                }
                @if (styleRef.otherPagesElementRefs.length) {
                  <p class="references-category">On Other Pages</p>
                  <ul class="references-list">
                    @for (
                      elementRef of styleRef.otherPagesElementRefs;
                      track elementRef.elementId
                    ) {
                      <li class="references-list-item" (click)="navigateToElement(elementRef)">
                        <button
                          type="button"
                          class="reference-button"
                          (click)="navigateToElement(elementRef)"
                        >
                          <mat-icon svgIcon="icon_search_16" />
                          <span>{{ elementRef.name }}</span>
                        </button>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          </blaze-scroller>
        }
      </li>
    }
  </ul>
</ng-template>

<ng-template #noReferencesTpl>
  <div class="empty-list-notification">
    <p class="font-medium mb-16">No styles created yet!</p>
    <p class="mb-16">Navigate to a component's Style Tab, adjust styling options, and save.</p>
    <p>Your saved styles will appear here.</p>
  </div>
</ng-template>
